import styled from 'styled-components';

import Exclamation from '~/components/Elements/Exclamation';

const Wrapper = styled.div`
  margin-top: 5px;
  font-size: 14px;
  font-style: italic;
`;

const Info = styled.div`
  margin-bottom: 5px;
`;

const FirstTime = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 3px;
  }
`;

const EquipmentInfo = () => (
  <Wrapper>
    <Info>
      * Uppgifter om balans och vagn hämtas från Svensk Travsport. Informationen
      om huvudlag bygger på uppgifter som vi har tagit del av. Rödmarkerad text
      signalerar en förändring från senaste starten.
    </Info>
    <FirstTime>
      <Exclamation />
      Hästen tävlar med utrustningen för första gången.
    </FirstTime>
  </Wrapper>
);

export default EquipmentInfo;
